import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import AuthLayout from '../../components/shared/AuthLayout/AuthLayout';
import { getOrganizationGeneralSignup } from '../../redux/actions/organizationActions';
import baseServerUrl from '../../services/apiServer';

import styles from './OrganizationSignup.module.scss';

const OrganizationSignup = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { organizationIdentifier } = useParams();

  const { currentOrganization: organization, organizationIdentifierLoading: loading } = useSelector(
    (state) => state.organizationsReducer
  );

  const decodedIdentifier = organizationIdentifier ? decodeURI(organizationIdentifier).replace(/%2f/g, '/') : '';

  useEffect(() => {
    if (decodedIdentifier) {
      dispatch(getOrganizationGeneralSignup(decodedIdentifier));
    }
  }, [dispatch, decodedIdentifier]);

  useEffect(() => {
    if (organization && !loading) {
      localStorage.setItem('generalSignupOrganizationId', organization.id);

      const signupUrl = `${baseServerUrl}/signup?org_id=${organization.id}`;
      window.location.href = signupUrl;
    }
  }, [organization, loading]);

  return (
    <AuthLayout>
      <div className={styles.container}>
        <div className={styles.loadingContent}>
          <div className={styles.spinner} />
          <h2 className={styles.title}>{t('signUp.settingUp')}</h2>
          <p className={styles.subtitle}>{t('signUp.preparingAccount', { organization: decodedIdentifier })}</p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OrganizationSignup;
